type AssetTypeOrigin = {
	appKey: string;
	originId: string;
};

type AssetTypeLabel = {
	value: string;
};

export type AssetType = {
	origin: AssetTypeOrigin;
	label: AssetTypeLabel;
};

export type AssetTypesResponse = {
	values: AssetType[];
	start: number;
	limit: number;
	size: number;
	isLastPage: boolean;
};

export const FetchingStates = Object.freeze({
	INIT: Symbol('init'),
	LOADING: Symbol('loading'),
	LOADED: Symbol('loaded'),
	FAILED: Symbol('failed'),
});

export type FetchingState = (typeof FetchingStates)[keyof typeof FetchingStates];

export type State = {
	assetTypes: AssetType[];
	fetchingState: FetchingState;
	error: Error | undefined;
};

export type ContainerProps = {
	baseUrl: string;
};
